var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 248,
    viewBox: "0 0 120 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2028_9610)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 114,
    height: 244,
    rx: 14,
    fill: "#F2F5FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_2028_9610)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.6289,
    y: -99.9824,
    width: 158.707,
    height: 158.707,
    rx: 79.3534,
    fill: "url(#paint0_linear_2028_9610)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2028_9610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.711 0H17.7353C8.48494 0 0.957031 7.5481 0.957031 16.8233C0.957031 20.2136 0.957031 228.17 0.957031 231.241C0.957031 240.516 8.48494 248.064 17.7353 248.064H102.711C111.962 248.064 119.49 240.516 119.49 231.241C119.49 228.234 119.49 20.2775 119.49 16.8233C119.49 7.5481 111.962 0 102.711 0ZM117.831 230.601C117.831 239.3 110.813 246.337 102.137 246.337H18.3095C9.63327 246.337 2.61572 239.3 2.61572 230.601C2.61572 227.595 2.61572 20.7893 2.61572 17.399C2.61572 8.69951 9.63327 1.59917 18.3095 1.59917H102.073C110.75 1.59917 117.767 8.63554 117.767 17.399C117.831 20.7893 117.831 227.595 117.831 230.601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.42285 5.82003C8.80403 2.74962 13.2697 0.382842 18.4372 0.446809L99.0114 0.574743C109.474 1.21441 118.724 6.97144 119.043 19.1891C119.043 20.5324 119.745 8.95442 112.281 3.83706C108.708 1.27838 103.477 0.126974 100.287 0.126974C95.1198 -0.000960081 26.8583 -0.0649271 18.501 0.126974C11.5473 0.318875 8.22987 3.13342 5.42285 5.82003Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.137 1.59961H18.309C9.63278 1.59961 2.61523 8.63598 2.61523 17.3995C2.61523 20.7897 2.61523 227.595 2.61523 230.601C2.61523 239.301 9.63278 246.337 18.309 246.337H102.073C110.749 246.337 117.767 239.301 117.767 230.601C117.767 227.595 117.767 20.7897 117.767 17.3995C117.831 8.69994 110.813 1.59961 102.137 1.59961ZM117.001 230.154C117.001 238.661 110.111 245.57 101.626 245.57H18.8194C10.3345 245.57 3.44458 238.661 3.44458 230.154C3.44458 227.147 3.44458 21.2375 3.44458 17.8472C3.44458 9.33961 10.3345 2.43118 18.8194 2.43118H101.626C110.111 2.43118 117.001 9.33961 117.001 17.8472C117.001 21.2375 117.001 227.147 117.001 230.154Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.137 246.465H18.3093C9.6331 246.465 2.55176 239.364 2.55176 230.601V17.399C2.55176 8.63549 9.6331 1.53516 18.3093 1.53516H102.073C110.813 1.53516 117.895 8.63549 117.895 17.399V230.601C117.895 239.364 110.813 246.465 102.137 246.465ZM18.3093 1.72706C9.69689 1.72706 2.67935 8.76343 2.67935 17.399V230.601C2.67935 239.236 9.69689 246.273 18.3093 246.273H102.073C110.686 246.273 117.703 239.236 117.703 230.601V17.399C117.703 8.76343 110.686 1.72706 102.073 1.72706H18.3093ZM101.627 245.633H18.8197C10.2711 245.633 3.3811 238.661 3.3811 230.153V17.8467C3.3811 9.27516 10.3349 2.36673 18.8197 2.36673H101.627C110.175 2.36673 117.065 9.33913 117.065 17.8467V230.153C117.129 238.725 110.175 245.633 101.627 245.633ZM18.8197 2.49466C10.3986 2.49466 3.5087 9.4031 3.5087 17.8467V230.153C3.5087 238.597 10.3986 245.505 18.8197 245.505H101.627C110.048 245.505 116.938 238.597 116.938 230.153V17.8467C116.938 9.4031 110.048 2.49466 101.627 2.49466H18.8197Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.42285 242.242C8.80403 245.313 13.2697 247.68 18.4372 247.616L99.0114 247.488C109.474 246.848 118.724 241.091 119.043 228.873C119.043 227.53 119.745 239.108 112.281 244.225C108.708 246.784 103.477 247.935 100.287 247.935C95.1198 248.063 26.8583 248.127 18.501 247.935C11.5473 247.744 8.22987 244.865 5.42285 242.242Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.872 51.877H119.489V78.4233H119.872V51.877Z",
    fill: "url(#paint1_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.809 78.4233V51.877L120 52.1328C119.872 54.0518 119.936 76.3123 120 78.2314L119.809 78.4233Z",
    fill: "url(#paint2_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.574181 51.877H0.191406V69.7237H0.574181V51.877Z",
    fill: "url(#paint3_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.191388 69.7237V51.877L0 52.1328C0.127592 54.0518 0.0637959 67.6128 0 69.5318L0.191388 69.7237Z",
    fill: "url(#paint4_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.956994 51.877H0.574219V69.7237H0.956994V51.877Z",
    fill: "url(#paint5_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.574181 74.2656H0.191406V92.1124H0.574181V74.2656Z",
    fill: "url(#paint6_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.191388 92.048V74.2012L0 74.457C0.127592 76.3761 0.0637959 89.9371 0 91.8561L0.191388 92.048Z",
    fill: "url(#paint7_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.956994 74.2656H0.574219V92.1124H0.956994V74.2656Z",
    fill: "url(#paint8_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.574181 30.7676H0.191406V40.4266H0.574181V30.7676Z",
    fill: "url(#paint9_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.191388 40.4266V30.7676L0 31.0234C0.127592 32.9425 0.0637959 38.3157 0 40.2347L0.191388 40.4266Z",
    fill: "url(#paint10_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.956994 30.7676H0.574219V40.4266H0.956994V30.7676Z",
    fill: "url(#paint11_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0922 247.553H54.3537C54.0985 247.553 53.9072 247.553 53.8434 247.617L53.333 247.809C53.2054 247.873 53.4606 247.937 53.8434 247.937H66.6025C66.9853 247.937 67.2405 247.873 67.1129 247.809L66.6025 247.617C66.5387 247.617 66.3473 247.553 66.0922 247.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6863 13.7522H49.3147C46.8904 13.7522 44.9766 11.7693 44.9766 9.40249C44.9766 6.97174 46.9542 5.05273 49.3147 5.05273H70.6863C73.1105 5.05273 75.0244 7.03571 75.0244 9.40249C75.0244 11.7693 73.1105 13.7522 70.6863 13.7522Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4734 11.3224C70.5305 11.3224 71.3873 10.4632 71.3873 9.40338C71.3873 8.34354 70.5305 7.48438 69.4734 7.48438C68.4164 7.48438 67.5596 8.34354 67.5596 9.40338C67.5596 10.4632 68.4164 11.3224 69.4734 11.3224Z",
    fill: "url(#paint12_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.6699,
    y: 7.59375,
    width: 3.82775,
    height: 3.83802,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4732 10.4913C70.0722 10.4913 70.5577 10.0044 70.5577 9.40384C70.5577 8.80327 70.0722 8.31641 69.4732 8.31641C68.8742 8.31641 68.3887 8.80327 68.3887 9.40384C68.3887 10.0044 68.8742 10.4913 69.4732 10.4913Z",
    fill: "url(#paint13_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4305 9.40286C70.4305 9.9146 69.9839 10.3624 69.4735 10.3624C68.9632 10.3624 68.5166 9.9146 68.5166 9.40286C68.5166 8.89113 68.9632 8.44336 69.4735 8.44336C69.9839 8.44336 70.4305 8.89113 70.4305 9.40286Z",
    fill: "url(#paint14_linear_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4305 9.40286C70.4305 9.9146 69.9839 10.3624 69.4735 10.3624C68.9632 10.3624 68.5166 9.9146 68.5166 9.40286C68.5166 8.89113 68.9632 8.44336 69.4735 8.44336C69.9839 8.44336 70.4305 8.89113 70.4305 9.40286Z",
    fill: "url(#paint15_radial_2028_9610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3665 9.91554C70.3665 9.72364 70.2389 9.5957 70.0475 9.5957C69.8561 9.5957 69.7285 9.72364 69.7285 9.91554C69.7285 10.1074 69.8561 10.2354 70.0475 10.2354C70.1751 10.2354 70.3665 10.1074 70.3665 9.91554Z",
    fill: "url(#paint16_radial_2028_9610)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2028_9610",
    x: -110.353,
    y: -191.707,
    width: 342.155,
    height: 342.155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.8621,
    result: "effect1_foregroundBlur_2028_9610"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2028_9610",
    transform: "scale(0.166667)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2028_9610",
    x1: -2.53364,
    y1: -93.2575,
    x2: 134.365,
    y2: -79.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2028_9610",
    x1: 119.65,
    y1: 51.8838,
    x2: 119.65,
    y2: 78.4172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185053,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381953,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9049,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9391
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2C2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2028_9610",
    x1: 119.935,
    y1: 51.8884,
    x2: 119.935,
    y2: 78.4181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0640242,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9191,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A0A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2028_9610",
    x1: 0.379604,
    y1: 51.8838,
    x2: 0.379604,
    y2: 69.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185053,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381953,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9049,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9391
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2C2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2028_9610",
    x1: 0.0948645,
    y1: 51.8884,
    x2: 0.0948645,
    y2: 69.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0640242,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9191,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A0A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2028_9610",
    x1: 0.772751,
    y1: 69.7232,
    x2: 0.772751,
    y2: 51.8884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0530612
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262C31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2028_9610",
    x1: 0.379604,
    y1: 74.2445,
    x2: 0.379604,
    y2: 92.0784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185053,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381953,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9049,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9391
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2C2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2028_9610",
    x1: 0.0948647,
    y1: 74.2486,
    x2: 0.0948647,
    y2: 92.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0640242,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9191,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A0A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2028_9610",
    x1: 0.772751,
    y1: 92.084,
    x2: 0.772751,
    y2: 74.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0530612
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262C31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2028_9610",
    x1: 0.379604,
    y1: 30.769,
    x2: 0.379604,
    y2: 40.4473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185053,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381953,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9049,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9391
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2C2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2028_9610",
    x1: 0.0948644,
    y1: 30.7737,
    x2: 0.0948644,
    y2: 40.4481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0640242,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9191,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A0A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2028_9610",
    x1: 0.772751,
    y1: 40.4528,
    x2: 0.772751,
    y2: 30.7737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0530612
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262C31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2028_9610",
    x1: 69.4831,
    y1: 11.1796,
    x2: 69.4831,
    y2: 7.43026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2028_9610",
    x1: 69.4829,
    y1: 8.3741,
    x2: 69.4829,
    y2: 10.5164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B131C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2028_9610",
    x1: 70.1536,
    y1: 10.0671,
    x2: 68.807,
    y2: 8.72414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0831767,
    stopColor: "#222326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1958,
    stopColor: "#1F2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3254,
    stopColor: "#1A3D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4675,
    stopColor: "#13537C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0B71AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7788,
    stopColor: "#0094EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7847,
    stopColor: "#0095EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7998,
    stopColor: "#0488D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8384,
    stopColor: "#0D689F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8761,
    stopColor: "#154E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    stopColor: "#1B394E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9455,
    stopColor: "#1F2B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9758,
    stopColor: "#222225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2028_9610",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4827 9.39391) scale(0.949027 0.951573)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2019,
    stopColor: "#175168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3838,
    stopColor: "#0D78A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    stopColor: "#0695CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6597,
    stopColor: "#02A7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7326,
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    stopColor: "#02A6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8055,
    stopColor: "#0693C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#0E749C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#184A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2028_9610",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.0038 9.89129) scale(0.338884 0.339793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0241236,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2198,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4085,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7482,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8915,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2028_9610"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 114,
    height: 244,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2028_9610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 248,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2028_9610",
    width: 6,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHZJREFUeNocjVEOwjAMQ51saiBJ+WVfaFcA7n8AEAeiEl1I+/xjJZZNt32P1hpKKTAzuFd83i+i67YFEpET1HTY+VyLCChVLxV6VjAzIgKru8+UqqGmJ2K09gWbORZe5kYpguPo6L1nR3J/PEOy8peHwRj/CzAAVmIcoerHSk0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePreview);
export default __webpack_public_path__ + "static/media/PhonePreview.1b06b8012177d2afdf7de3daa2fde59b.svg";
export { ForwardRef as ReactComponent };